import { SelectItem } from 'primeng/api';

import { PageResponse } from '..';
import { Clientfile, ClientfileTypes } from './clientfile';


export class ReleaseBundle {
    id?: string;
    releaseNotes?: string;
    status?: string;
    majorVersion?: number;
    minorVersion?: number;
    patchVersion?: number;
    buildNumber?: number;
    creationdate?: string;
    modifydate?: string;
    clientFiles?: Clientfile[];

    getClientFileByType(
        type: string
    ): Clientfile {
        return this.clientFiles != null
            ? this.clientFiles.filter(clientFile => clientFile.type === type)[0]
            : null;
    }

    getVersion(): string {
        return (
            this.majorVersion +
            '.' +
            this.minorVersion +
            '.' +
            this.patchVersion +
            '.' +
            this.buildNumber
        );
    }

    getStatus(): string {
        switch (this.status) {
            case 'A': {
                return 'Active';
            }
            case 'I': {
                return 'Inactive';
            }
            case 'QA': {
                return 'Experimental';
            }
            default: {
                return status;
            }
        }
    }
}



export class ReleaseBundleResponse extends PageResponse {
    content: ReleaseBundle[];
}


export class CreateReleaseBundleRequest {
    constructor(public releaseNotes: string, public majorVersion: number, public minorVersion: number,
        public patchVersion: number, public buildNumber: number,  public clientFiles: Clientfile[]) {}
}


export class UpdateReleaseBundleRequest {
    constructor(public releaseNotes: string, public majorVersion: number, public minorVersion: number,
        public patchVersion: number, public buildNumber: number,  public clientFiles: Clientfile[], public status: string) {
    }
}



